<template>
  <div :style="{ width: width, heigth: height }">

    <div
      :style="{
        fontSize: fontSize(),
        fontFamily: chartConfig.fontFamily,
        color: chartConfig.color,
        textAlign: align,
        verticalAlign: valign,
        letterSpacing: letterSpacing,
        fontWeight: chartConfig.fontWeight,
        border: chartConfig.border,
        backgroundColor: chartConfig.backgroundColor,
        backgroundImage: getBackgroundImage,
        margin: chartConfig.margin,
        padding: chartConfig.padding,
      }"
      v-for="(item, index) in endValue" :key="index" style="display: inline-block"
    >
      <numberComponents v-if="item != '.'"
      :playTimer="animalConfig.playTimer"
       :isOpenPlayTimer="animalConfig.isOpenPlayTimer"
       :duration="animalConfig.duration" :endValue="item"></numberComponents>
      <span v-else>{{ item }}</span>
    </div>
  </div>
</template>
<script>
import numberComponents from './components/numberComponents.vue';
export default {
  components: {
    numberComponents,
  },
  props: {
    width: {
      type: String,
      default: "300px",
    },
    height: {
      type: String,
      default: "30px",
    },
    screen: {
      type: Object,
      default() {
        return {
          height: 1920,
          width: 1280,
        };
      },
    },
    page: {
      type: Object,
      default() {
        return {
          height: 1920,
          width: 1280,
        };
      },
    },
    //动画配置
    animalConfig:{
      type: Object,
      default(){
        return {
          duration:7000,
          //动画刷新检测
          playTimer:30000,
          //是否开启动画刷新
          isOpenPlayTimer:'1'
        }
      }
    },
    chartConfig: {
      type: Object,
      default: function () {
        return {
          fontSize: 24,
          fontFamily: "微软雅黑",
          name: "标准标题",
          // color:'#fff',
          align: "center",
          verticalAlign: "middle",
          letterSpacing: 8,
          value: 10000,
          fontWeight: "normal",
          border: "1px solid red",
          backgroundColor: "transparent",
          backgroundImage: "",
          margin: "2px",
          isSeparate: "1",
          padding: "10px",
          duration:7000,
          //动画刷新检测
          playTimer:30000,
          //是否开启动画刷新
          isOpenPlayTimer:'1'
        };
      },
    },
  },
  computed: {
    getBackgroundImage() {
      if (this.chartConfig.backgroundImage) {
        return "url(" + this.chartConfig.backgroundImage + ") no-report";
      }
      return "";
    },
    endValue() {
      let values = [];

      if (this.chartConfig && this.chartConfig.value) {
        if (this.chartConfig.isSeparate == "1") {
          let tempValue = this.chartConfig.value + "";
          for (let i = 0; i < tempValue.length; i++) {
            if (tempValue[i] != ".") {
              values.push(parseInt(tempValue[i]));
            } else {
              values.push(tempValue[i]);
            }
          }
        } else {
          values.push(this.chartConfig.value);
        }
        return values;
      }
      return values.push(0);
    },
    letterSpacing() {
      return this.chartConfig.letterSpacing + "px";
    },

    align() {
      if (!this.chartConfig.align) {
        return "left";
      }
      return this.chartConfig.align;
    },
    valign() {
      if (!this.chartConfig.verticalAlign) {
        return "middle";
      }
      return this.chartConfig.verticalAlign;
    },
  },
  data() {
    return {
      timer:null
    }
  },
  watch:{
  },
  mounted() {

  },
  beforeDestroy(){

  },
  methods: {
    fontSize() {
      let _fontSize = this.chartConfig.fontSize
        ? this.chartConfig.fontSize
        : 14;
      let fontSize = (_fontSize / this.page.width) * this.screen.width;
      return fontSize + "px";
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/Number.vue